import { render, staticRenderFns } from "./OctCheckbox.vue?vue&type=template&id=38449f92&scoped=true&"
import script from "./OctCheckbox.vue?vue&type=script&lang=js&"
export * from "./OctCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./OctCheckbox.vue?vue&type=style&index=0&id=38449f92&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38449f92",
  null
  
)

export default component.exports